import AudiotrackIcon from "@mui/icons-material/Audiotrack";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";

export const getFileTypeIcon = (mimeType: string) => {
    switch (true) {
        case mimeType.startsWith("image"):
            return <ImageIcon />;
        case mimeType.includes("pdf"):
            return <PictureAsPdfIcon />;
        case mimeType.includes("audio"):
            return <AudiotrackIcon />;
        case mimeType.includes("video"):
            return <VideoLibraryIcon />;
        default:
            return <InsertDriveFileIcon />;
    }
};
